
import styled from "styled-components";

interface LogoProps {
  src: string;
}
const LogoContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BrandLogo = ({ src }: LogoProps) => {
  return <LogoContainer src={src} alt="" />;
};

export default BrandLogo;
